// extracted by mini-css-extract-plugin
module.exports = {"shopGroupWrapper":"_3uk--UD5FIFJ9TopmSY82L"};